import type { PropsWithChildren, ReactNode } from 'react';
import { styled } from '@volkswagen-onehub/components-core';

const StyledSideTabsFixedTopContainerWrapper = styled.div`
  position: sticky;
  top: 250px;
  height: max-content;
  padding-bottom: ${(props) => props.theme.size.static650};
`;

interface TabsWrapper {
  children?: React.ReactNode;
}


export default ({ children }: TabsWrapper) => {
  return (
    <StyledSideTabsFixedTopContainerWrapper>
      {children}
    </StyledSideTabsFixedTopContainerWrapper>
  );
};
